// AboutUs.jsx
import React from "react";
import { motion } from "framer-motion";

const AboutUs = () => {
  // Custom Button Component (inline)
  const Button = ({
    children,
    variant = "primary",
    className = "",
    ...props
  }) => {
    const base =
      "inline-block font-semibold transition-all duration-300 rounded-full px-6 py-3";
    const styles = {
      primary: "bg-blue-700 text-white hover:bg-blue-800",
      outline:
        "border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white",
      secondary: "bg-white text-blue-700 hover:bg-gray-100 border border-white",
    };
    return (
      <button className={`${base} ${styles[variant]} ${className}`} {...props}>
        {children}
      </button>
    );
  };

  return (
    <div className="w-full text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gray-50 pt-20">
        <div className="container mx-auto px-6 text-center max-w-5xl">
          <motion.h1
            className="text-5xl md:text-6xl font-bold   font-Agatho_Regular  mb-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Fostering Unity Through Global Partnerships
          </motion.h1>
          <p className="text-lg md:text-xl mb-8 text-gray-600">
            In an age where globalization dissolves boundaries, the Indo
            European Business Council builds bridges across cultural,
            commercial, and institutional landscapes.
          </p>
          {/* <Button variant="primary">Discover More</Button> */}
        </div>
        <div className="mt-10 w-full h-[600px] bg-gray-200 rounded-xl flex items-center justify-center text-gray-500">
          <img
            src="/Images/image26.jpeg"
            alt="Fostering Unity Through Global Partnerships"
            className="object-cover w-full h-full rounded-xl"
            style={{ maxWidth: "100%", maxHeight: "100%", objectPosition: "center" }}
          />
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-4">
            <h2 className="text-4xl  font-Agatho_Regular  font-bold text-gray-900">
              Our Vision
            </h2>
            <p>
              By fostering multifaceted connections, the Indo European Business
              Council embeds economic cooperation into the very fabric of our
              societies—paving the way for long-term, cross-border impact.
            </p>
            {/* <Button variant="outline">Find Out More</Button> */}
          </div>
          <div className="w-full h-[350px] bg-gray-200 rounded-xl flex items-center justify-center text-gray-500 overflow-hidden">
            <img
              src="/Images/image12.jpeg"
              alt="Our Vision"
              className="object-cover w-full h-full rounded-xl"
              style={{ objectPosition: "center" }}
            />
          </div>
        </div>

        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 mt-20 items-center">
          <div className="w-full h-[350px] bg-gray-200 rounded-xl flex items-center justify-center text-gray-500 overflow-hidden">
            <img
              src="/Images/image14.jpeg"
              alt="Our Mission"
              className="object-cover w-full h-full rounded-xl"
              style={{ objectPosition: "center" }}
            />
          </div>
          <div className="space-y-4">
            <h2 className="text-4xl  font-Agatho_Regular  font-bold text-gray-900">
              Our Mission
            </h2>
            <p>
              Comprising a dynamic council of forward-thinking professionals,
              the <strong>Indo European Business Council</strong> advances business interests
              across India, Europe, and beyond—fostering innovation and
              sustainable growth.
            </p>
       
            {/* <Button variant="outline">Find Out More</Button> */}
          </div>
        </div>
      </section>

      {/* Our Aim */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center max-w-4xl">
          <h2 className="text-4xl  font-Agatho_Regular  font-bold mb-4">
            Our Aim
          </h2>
          <p className="mb-6 text-gray-700">
            Empowering Businesses for a Resilient Future — where startups and
            corporates alike thrive together, elevating economies and shaping a
            sustainable global future.
          </p>
          <ul className="grid md:grid-cols-2 gap-4 text-left text-gray-700 max-w-xl mx-auto">
            <li>• Economically resilient</li>
            <li>• Technologically agile</li>
            <li>• Socially responsible</li>
            <li>• Collaboratively connected</li>
          </ul>
          {/* <Button variant="primary" className="mt-6">
            Learn More
          </Button> */}
        </div>
      </section>

      {/* Core Principles */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-6xl">
          <h2 className="text-4xl  font-Agatho_Regular  font-bold text-center mb-10">
            Our Core Principles
          </h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-3xl   font-Agatho_Regular  font-semibold mb-2">
                Inclusivity at the Core
              </h3>
              <p className="text-gray-700">
                We champion accessibility and representation, ensuring
                initiatives are open to women-led enterprises, youth
                entrepreneurs, micro-businesses, and underrepresented sectors.
              </p>
            </div>
            <div>
              <h3 className="text-3xl  font-Agatho_Regular  font-semibold mb-2">
                Embracing Technological Advancement
              </h3>
              <p className="text-gray-700">
                Supporting members with digital adoption, cross-border trade
                facilitation, and innovation aligned with both Indian and
                European ecosystems.
              </p>
            </div>
          </div>
          <div className="mt-12 w-full h-[450px] bg-gray-200 rounded-xl flex items-center justify-center text-gray-500">
            <img
              src="/Images/image15.jpeg"
              alt="Illustration of Core Principles"
              className="w-full h-full object-cover rounded-xl shadow-md"
            />
          </div>
        </div>
      </section>

      {/* Join the Movement */}
      <section className="py-20 bg-blue-700 text-white text-center">
        <div className="container mx-auto px-6 max-w-3xl">
          <h2 className="text-4xl  font-Agatho_Regular  font-bold mb-4">
            Join the Movement
          </h2>
          <p className="mb-8 text-lg">
            Be part of a community that thinks globally, acts locally, and
            connects meaningfully. With <strong className="font-bold">Indo European Business Council</strong>, you’re
            not just witnessing a changing world—you’re shaping it.
          </p>
     
          {/* <Button variant="secondary">Become a Member</Button> */}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
